/*!
 * Stimpack Control - Tax Query
 *
 * @version : 1.0.0
 * @author  : Matthias Courville
 */

import { spIsBase64, spBase64Encode, spBase64Decode } from '../utilities/utilities';

(function($) {

    var spControlTaxQueryTermsCache = [];

    var spControlTaxQuery = function(el, options)
    {
        var _this = this,
            root = $(el);

        this.options = $.extend({
            'name'          : '',
            'ruleTemplate'  : '',
            'groupTemplate' : '',
            'selectors'     : {
                'rule'              : '.sp-control-tax-query-rule',
                'group'             : '.sp-control-tax-query-group'
            }
        }, options);

        this.el = {
            root : root,
        };

        this.init();

        this.refresh();
    };

    /*
     *
     */
    spControlTaxQuery.prototype.refresh = function()
    {
        var _this = this;

        this.el.root.find('.sp-control-tax-query-group').each(function() {
            _this.refreshGroup($(this));
        });

        console.log(this.getValue());
        this.updateJsonOutput(this.getValue());
    }

    /*
     *
     */
    spControlTaxQuery.prototype.init = function()
    {
        var _this = this;

        this.el.root.on('click', '.sp-control-tax-query-add-rule', function(e) {
            e.preventDefault();
            _this.addRule($(this).closest(_this.options.selectors.group));
        });

        this.el.root.on('click', '.sp-control-tax-query-add-group', function(e) {
            e.preventDefault();
            _this.addGroup($(this).closest(_this.options.selectors.group));
        });

        this.el.root.on('click', '.sp-control-tax-query-remove-rule', function(e) {
            e.preventDefault();
            _this.removeRule($(this).closest(_this.options.selectors.rule));
        });

        this.el.root.on('click', '.sp-control-tax-query-remove-group', function(e) {
            e.preventDefault();
            _this.removeGroup($(this).closest(_this.options.selectors.group));
        });

        this.el.root.on('change', '.sp-control-tax-query-taxonomy-select', function(e) {
            _this.updateRuleTerms($(this).closest(_this.options.selectors.rule), $(this).val());
        });

        this.el.root.on('change', 'select', function(e) {
            _this.refresh();
        });
    };


    /*
     *
     */
    spControlTaxQuery.prototype.getPath = function(group)
    {
        var target = group.find('.sp-control-tax-query-group-children').first(),
            children = target.children(),
            parents = group.parents('.sp-control-tax-query-group'),
            path = '';

        parents.add(group).each(function() {

            if ($(this).closest('.sp-control-tax-query-group-children').length > 0)
            {
                path += '[' + $(this).index() + ']';
            }
        });

        path += '[' + (children.length || 0) + ']';

        return path;
    }

    /*
     *
     */
    spControlTaxQuery.prototype.addItem = function(group, item)
    {
        item.find('[data-sp-control-select]').each(function() {
            $(this).spControlSelect();
        });

        group.find('.sp-control-tax-query-group-children').first().append(item);

        this.refresh();
    };

    /*
     *
     */
    spControlTaxQuery.prototype.addGroup = function(group)
    {
        var newGroup = $(this.options.groupTemplate.replace(new RegExp(/\[\[path\]\]/g), this.getPath(group)));
        this.addItem(group, newGroup);
        this.addRule(newGroup);
        this.addRule(newGroup);
    };

    /*
     *
     */
    spControlTaxQuery.prototype.addRule = function(group)
    {
        var rule = $(this.options.ruleTemplate.replace(new RegExp(/\[\[path\]\]/g), this.getPath(group)));
        this.addItem(group, rule);
    };

    /*
     *
     */
    spControlTaxQuery.prototype.removeItem = function(item)
    {
        item.remove();
        this.refresh();
    };

    /*
     *
     */
    spControlTaxQuery.prototype.removeGroup = function(group)
    {
        this.removeItem(group);
    };

    /*
     *
     */
    spControlTaxQuery.prototype.removeRule = function(rule)
    {
        this.removeItem(rule);
    };


    /*
     *
     */
    spControlTaxQuery.prototype.refreshGroup = function(group)
    {
        var children = group.find('> .sp-control-tax-query-group-children').children(),
            rootChildren = this.el.root.find('.sp-control-tax-query-group > .sp-control-tax-query-group-children').first().children();

        group.attr('data-tax-query-children-count', children.length);
        this.el.root.attr('data-tax-query-count', rootChildren.length);
    };

    /*
     *
     */
    spControlTaxQuery.prototype.updateRuleTerms = function(rule, taxonomy)
    {
        var select = rule.find('.sp-control-tax-query-terms-select'),
            selectInstance = select.data('select2');

        select.attr('disabled', 'disabled');

        this.getTerms(taxonomy, function (terms) {

            var placeholder = 'Terms';

            select.empty();

            if (terms.length > 0)
            {
                $.each(terms, function(index, term) {
                    var option = new Option(term.name, term.term_id, false, false);
                    select.append(option);
                });

                select.removeAttr('disabled');
            }
            else
            {
                placeholder = 'No terms found...';
            }

            select.next("span.select2:first").find("span.select2-selection__placeholder").html(placeholder);
            selectInstance.selection.placeholder.text = placeholder;

            select.val(null).trigger('change');
        });
    };

    /*
     * Get Terms
     */
    spControlTaxQuery.prototype.getTerms = function(taxonomy, callback)
    {
        var _this = this;

        if (typeof spControlTaxQueryTermsCache[taxonomy] !== 'undefined')
        {
            callback.call(this, spControlTaxQueryTermsCache[taxonomy]);
        }
        else
        {
            $.ajax({
                url         : STIMPACK.ajaxUrl,
                type        : 'post',
                data        : {
                    action  : 'stimpack_get_terms',
                    options : {
                        taxonomy: taxonomy
                    }
                },
                dataType    : 'json',
                success     : function(data) {

                    if (data)
                    {
                        spControlTaxQueryTermsCache[taxonomy] = data;
                        callback.call(_this, data);
                    }
                },
                error       : function(data) {},
                timeout     : 10000
            });
        }
    };

    /*
     * Get Terms
     */
    spControlTaxQuery.prototype.getValue = function()
    {
        var container = this.el.root.find('.sp-control-tax-query-group').first(),
            json = container.find('select').serializeJSON({useIntKeysAsArrayIndex: false});

        if (typeof json === 'object')
        {
            if (typeof json[this.options.name] === 'object')
            {
                json = json[this.options.name];
            }
            else if (typeof json.acf === 'object')
            {
                json = json.acf;
                json = json[Object.keys(json)[0]];
            }

            return json;
        }
    };

    /*
     * Update json input
     */
    spControlTaxQuery.prototype.updateJsonOutput = function(value)
    {
        var input = this.el.root.find('.sp-control-tax-query-encoded-output');

        value = typeof value === 'object' ? spBase64Encode(JSON.stringify(value)) : null;

        this.el.root.find('.sp-control-tax-query-encoded-output').val(value);
    }

    $.fn.spControlTaxQuery = function(options)
    {
        options = options || {};

        return this.each(function() {

            var _options = $(this).data('sp-control-tax-query');

            $(this).attr('data-sp-control-tax-query', true);

            if (_options)
            {
                if (typeof _options == 'object')
                {
                    options = $.extend({}, options, _options);
                }
                else if (spIsBase64(_options))
                {
                    options = $.extend({}, options, _options ? JSON.parse(spBase64Decode(_options)) : {});
                }
            }

            this.spControlTaxQuery = new spControlTaxQuery(this, options);
        });
    };

    // Declaration
    $('[data-sp-control-tax-query]').each(function() {
        $(this).spControlTaxQuery();
    });


})(jQuery);
